import script from "./ElementText.vue?vue&type=script&lang=js"
export * from "./ElementText.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__